interface OrderStatus {
  label: string;
  color: string;
  textColor: string;
}

export const ORDER_STATUS_DATA: { [x: string]: OrderStatus } = {
  ORDWTC: {
    label: "Pesanan baru",
    color: "bg-yellow-lp-200",
    textColor: "text-yellow-lp-100"
  },
  ORDPRC: {
    label: "Diproses",
    color: "bg-blue-lp-200",
    textColor: "text-blue-lp-300"
  },
  ORDBKD: {
    label: "Perlu dikirim",
    color: "bg-aqua-lp-200",
    textColor: "text-aqua-lp-500"
  },
  ORDDLV: {
    label: "Dikirim",
    color: "bg-purple-lp-100",
    textColor: "text-purple-lp-800"
  },
  ORDRCV: {
    label: "Selesai",
    color: "bg-green-lp-300",
    textColor: "text-green-lp-400"
  },
  CNCWRF: {
    label: "Dibatalkan",
    color: "bg-red-lp-600",
    textColor: "text-red-lp-300"
  }
};
export const ORDER_STATUS = (status: string): OrderStatus => {
  return (
    ORDER_STATUS_DATA[status] || {
      label: "Status tidak dikenal",
      color: "bg-gray-200",
      textColor: "text-gray-300"
    }
  );
};
